export default {

    en: {
      $vuetify: {
        close: 'Close',
        dataIterator: {
          pageText: '{0}-{1} of {2}',
          noResultsText: 'No matching records found',
          loadingText: 'Loading items...',
        },
        dataTable: {
          itemsPerPageText: 'Rows per page:',
          ariaLabel: {
            sortDescending: ': Sorted descending. Activate to remove sorting.',
            sortAscending: ': Sorted ascending. Activate to sort descending.',
            sortNone: ': Not sorted. Activate to sort ascending.',
          },
        },
        dataFooter: {
          itemsPerPageText: 'Items per page:',
          itemsPerPageAll: 'All',
          nextPage: 'Next page',
          prevPage: 'Previous page',
          firstPage: 'First page',
          lastPage: 'Last page',
        },
        datePicker: {
          itemsSelected: '{0} selected',
        },
        noDataText: 'No data available',
        carousel: {
          prev: 'Previous visual',
          next: 'Next visual',
        },
        calendar: {
          moreEvents: '{0} more',
        },
      },
      
      
      'label': {
        'login': 'Login',
        'signup': 'Sign Up',
        'email': 'Email',
        'username': 'Username',
        'password': 'Password',
        'change_password': 'Change Password',
        'forgot_password': 'Forgot Password',
        'search': 'Search',
        'find': 'Find',
        'delete': 'Delete',
        'save': 'Save',
        'cancel': 'Cancel',
        'create': 'Create',
        'edit': 'Edit',
        'ok': 'OK',
        'back': 'Back',
        'close': 'Close',
        'error': 'Error',
        'warning': 'Warning',
        'assign': 'Assign',
        'undo': 'Undo',
        'select_all': 'Select All',
        'unselect_all': 'Unselect All',
        'reset': 'Reset',
        'dark_theme': 'Dark Theme',
        'default_color': 'Default Color',
        'confirm_delete': 'Confirm Delete',
        'confirm_repair': 'Confirm Repair',
        'confirm_cutout': 'Confirm Cut Out',
        'cannot_delete': 'Delete Error',
        'select_file': 'Select File',
        'additional_info': 'Additional Info',
        'update_available': 'Update available',
        'refresh': 'Refresh',
        'app_install': 'Install App',
        'install': 'Install',
        'syncdata': 'Sync Data', 
        'yes': 'Yes',
        'no': 'No',
        'unsaved_changes': 'Unsaved Changes',
        'error_details': 'Error Details',
        'url': 'URL',
        'error_msg': 'Error Message',
        'reject': 'Reject',
        'accept': 'Accept',

        'main_details': 'BOM List',

        'is_attachment': 'Is Attachment',
        'vis_details': 'vis',
        'is_complete': 'Complete',
        'status': 'Status',
        'comments': 'Comments',
        'image_title': 'Title',
        'image_notes': 'Notes',
        'image_seq': 'Sequence',
        'images': 'Photos',

      },
  

      'title': {
        'WelcomePage': 'Welcome',  
        
        'Tasks': 'Tasks',
        'ProjectsPage': 'Projects',
        'BOM': 'BOM',
        
        'DownloadErrorsPage': 'Download Errors',
        'DownloadErrorsViewPage': 'View Download Error'

      },
            
      'menu': {
        'syncdata': 'Sync Data', 

        'logout': 'Logout',
        'edit': 'Edit',
        'delete': 'Delete',
        'images': 'Photos',
        'list': 'List',
        'activewelds': 'Active Joints',
        'add': 'Add',
        'find': 'Find',
        'search': 'Search',

        'projects': 'Projects',
        'materials': 'Pipes & Fittings',
        'welds': 'Joints',  
        'repair': 'Repair',   
        'cutout': 'Cut Out',   

        'errors': 'Errors',
        'welderrors': 'Joint Upload Errors',
        'weldimageerrors': 'Photo Upload Errors',
        'itemerrors': 'Item Upload Errors',
        'downloaderrors': 'Download Errors',

      },
  

      'message': {
        'invalid_login': 'Invalid login attempt',
        'insufficient_permission': 'Forbidden. Insufficient Permission',
        'welcome_morning_msg': 'Good Morning,<br />welcome to PipemaX',
        'welcome_afternoon_msg': 'Good Afternoon,<br />welcome to PipemaX',
        'welcome_evening_msg': 'Good Evening,<br />welcome to PipemaX',
        'confirm_delete_msg': 'Are you sure you want to delete the selected record(s)?',
        'confirm_delete_weld_msg': 'Are you sure you want to delete joint {weld_id}',
        'confirm_repair_weld_msg': 'Are you sure you want to repair joint {weld_id}',
        'confirm_cutout_weld_msg': 'Are you sure you want to cut out joint {weld_id}',
        'confirm_delete_item_msg': 'Are you sure you want to delete item {item_id}',
        'cannot_delete_weld_msg': 'Unable to delete Joint {weld_id}, please use the desktop application to delete this joint',
        'delete_success_msg': 'Delete Successful',
        'delete_cancel_msg': 'Delete Cancelled',
        'logout_hdr_msg': 'Are you sure you want to logout?',
        'logout_msg': 'If you logout, you will be required to login again to use the system, which will require connectivity',
        'do_not_show_msg': "Don't show this again",
        'set_project_title': 'Set Default Project',
        'set_project_msg': 'Set Project to {project}?',
        'item_not_found': 'Item Not Found',
        'weld_not_found': 'Joint not found',
        'item_not_acceptable': 'Item Status is not Acceptable',
        'is_duplicate': 'This record already exists',
        'not_latest_weld_rev': 'This is not the latest revision',
        'status_not_repair': 'Status is not Repair',
        'status_not_cutout': 'Status is not Cut Out',
        'same_items': 'Items are the same',
        'item_weld_exceed': 'Item {item} has exceeded its joint limit',
        'missing_insp_date_status': 'When entering {inspection_details}, both the Result and Date must be provided',
        'sync_error': 'An error occurred during data sync.  Please try again',
        'sync_ok': 'Data Sync completed successfully',
        'unsaved_changes_msg': 'You have unsaved changes, are you sure you want to continue and loose these changes?',
      },
  
    },
  

  }
  